import { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast, Toaster } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const Attendance = () => {
  const [items, setItems] = useState([]);
  const [courses, setCourses] = useState([]);
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [form, setForm] = useState({ date: "", course_id: "", teacher_id: "", student_id: "", status: "present", paid: false });

  const load = () => api.get("/admin/attendance").then(r => setItems(r.data.sort((a, b) => (b.date || "").localeCompare(a.date || ""))));
  useEffect(() => {
    load();
    api.get("/admin/courses").then(r => setCourses(r.data));
    api.get("/admin/students").then(r => setStudents(r.data));
    api.get("/admin/teachers").then(r => setTeachers(r.data));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/attendance", form);
      toast.success("Erfasst");
      setForm({ ...form, student_id: "", status: "present" });
      load();
    } catch { toast.error("Fehler"); }
  };

  const remove = async (it) => {
    if (!window.confirm("Löschen?")) return;
    await api.delete(`/admin/attendance/${it.id}`);
    load();
  };

  return (
    <div className="space-y-6" data-testid="admin-attendance">
      <Toaster position="top-center" theme="light" />
      <h1 className="font-serif-display text-3xl">Anwesenheit</h1>

      <form onSubmit={submit} className="card-academy rounded-lg p-5 grid grid-cols-1 md:grid-cols-6 gap-3">
        <input type="date" required value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} className="bg-input/30 border border-border rounded-md px-3 py-2 text-sm" />
        <select required value={form.course_id} onChange={e => setForm({ ...form, course_id: e.target.value })} className="bg-input/30 border border-border rounded-md px-3 py-2 text-sm">
          <option value="">Kurs</option>
          {courses.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <select value={form.teacher_id} onChange={e => setForm({ ...form, teacher_id: e.target.value })} className="bg-input/30 border border-border rounded-md px-3 py-2 text-sm">
          <option value="">Lehrer</option>
          {teachers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
        <select required value={form.student_id} onChange={e => setForm({ ...form, student_id: e.target.value })} className="bg-input/30 border border-border rounded-md px-3 py-2 text-sm">
          <option value="">Schüler</option>
          {students.map(s => <option key={s.id} value={s.id}>{s.first_name} {s.last_name}</option>)}
        </select>
        <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })} className="bg-input/30 border border-border rounded-md px-3 py-2 text-sm">
          <option value="present">Anwesend</option>
          <option value="absent">Abwesend</option>
          <option value="excused">Entschuldigt</option>
        </select>
        <button type="submit" className="btn-gold rounded-md px-4 py-2 text-sm inline-flex items-center justify-center gap-2"><Plus className="w-4 h-4" />Erfassen</button>
      </form>

      <div className="card-academy rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/40 border-b border-border">
              <tr>{["Datum", "Kurs", "Schüler", "Status", ""].map(h => <th key={h} className="text-left text-xs uppercase tracking-[0.15em] text-muted-foreground px-4 py-3">{h}</th>)}</tr>
            </thead>
            <tbody>
              {items.map(a => {
                const c = courses.find(x => x.id === a.course_id);
                const s = students.find(x => x.id === a.student_id);
                return (
                  <tr key={a.id} className="border-b border-border/50">
                    <td className="px-4 py-2">{a.date}</td>
                    <td className="px-4 py-2">{c?.name || a.course_id}</td>
                    <td className="px-4 py-2">{s ? `${s.first_name} ${s.last_name}` : a.student_id}</td>
                    <td className="px-4 py-2 capitalize">{a.status}</td>
                    <td className="px-4 py-2 text-right"><button onClick={() => remove(a)} className="text-muted-foreground hover:text-destructive"><Trash2 className="w-4 h-4" /></button></td>
                  </tr>
                );
              })}
              {items.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-muted-foreground">Keine Einträge</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Attendance;
